import { z } from "zod";

export namespace BizJobTitleModels {
  /**
   * BizJobTitlePaginationFilterDtoSchema
   * @type { object }
   * @property { string } jobTitle
   */
  export const BizJobTitlePaginationFilterDtoSchema = z.object({ jobTitle: z.string() }).partial();
  export type BizJobTitlePaginationFilterDto = z.infer<typeof BizJobTitlePaginationFilterDtoSchema>;

  /**
   * BizJobTitlePaginationResponseDtoSchema
   * @type { object }
   * @property { string[] } items Items
   * @property { object[] } order List of order definitions
   * @property { number } page 1-indexed page number to begin from
   * @property { string } cursor ID of item to start after
   * @property { string } nextCursor Cursor for next set of items
   * @property { number } limit Items per response
   * @property { number } totalItems Total available items
   */
  export const BizJobTitlePaginationResponseDtoSchema = z.object({
    items: z.array(z.string()),
    order: z.array(z.object({})).optional(),
    page: z.number().optional(),
    cursor: z.string().optional(),
    nextCursor: z.string().optional(),
    limit: z.number(),
    totalItems: z.number(),
  });
  export type BizJobTitlePaginationResponseDto = z.infer<typeof BizJobTitlePaginationResponseDtoSchema>;
}
